export class FetchBarcodeListItemsAction {
  static readonly type = '[Barcodes] Fetch Barcode List Items';
}
